import { Directive, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';

@Directive({
	selector: '[pgsScrollablePane]',
})
export class ScrollablePaneDirective implements OnInit {

	@Input() pgsScrollablePane = '500';
	@Input() className = '';

	constructor(private el: ElementRef, private renderer: Renderer2) {

	}

	ngOnInit(): void {
        const parent = this.el.nativeElement.parentNode;
        const divElement = this.renderer.createElement('div');
		this.renderer.addClass(divElement, 'scrollable-pane');
		if (this.className) {
			this.renderer.addClass(divElement, this.className);
		}
		this.renderer.setStyle(divElement, 'maxHeight', this.pgsScrollablePane + 'px');
        this.renderer.insertBefore(parent, divElement, this.el.nativeElement);
        this.renderer.removeChild(parent, this.el.nativeElement);
        this.renderer.removeAttribute(this.el.nativeElement, 'pgsScrollablePane');
        this.renderer.appendChild(divElement, this.el.nativeElement);
	}
}
